import { Component } from "react";
import { withRouter } from "react-router-dom";

class ScrollTop extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    this.location = this.props.location.key;
    if (this.props.history.action !== "POP") {
      window.scrollTo(0, 0);
    }
  }

  componentDidUpdate() {
    if (this.location !== this.props.location.key) {
      this.location = this.props.location.key;
      if (this.props.history.action !== "POP") {
        window.scrollTo(0, 0);
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollTop);
